import { render, staticRenderFns } from "./Liabilities.vue?vue&type=template&id=e80bb222&scoped=true&"
import script from "./Liabilities.vue?vue&type=script&lang=js&"
export * from "./Liabilities.vue?vue&type=script&lang=js&"
import style0 from "./Liabilities.vue?vue&type=style&index=0&id=e80bb222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80bb222",
  null
  
)

export default component.exports